import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import { RetailerCreditCheckDeleteResponseType } from "@sellar-io/api-v2/types";

export const useDeleteBuyerCreditCheck = (buyerId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "delete",
        path: `retailers/${buyerId}/retailer-credit-check`,
      }).then(
        (response) =>
          apiV2AssertResponse(
            response,
          ) as RetailerCreditCheckDeleteResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Retailers, buyerId],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Retailers],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
      });
    },
  });
};
